module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Light.175b46b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Light.woff
// module id = m6M7
// module chunks = 0